module.exports = __webpack_public_path__ + "img/farming_47.b00521e2.png";